import React, { Component } from 'react';
import { getCartProducts, filterProducts, userlogin, getOffers } from '../../../repository';
import { AddToCartButton } from '../../../buttons';
import Loader from 'react-loader-spinner';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { library } from '@fortawesome/fontawesome-svg-core';
// import { faCheckSquare, faCoffee } from '@fortawesome/free-solid-svg-icons';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import parse from 'html-react-parser';
import "../../../custom-css/Custom.css";
// library.add( faCheckSquare, faCoffee)

let mattress_quantity = '';
let mattress_size= '';
let mattress_comfort = '';
let mattress_category;
let product_description = '';
const cookies = new Cookies();
let csrftoken = '';
let search, params, requested_size;

class Mattresspage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page_loading: true,
            loading: false,
            offers: [],
            vouchers: [],
            offers_set: false,
            capture_url_var: false,
            calc_is_done: false
        };
    }


    componentDidMount() {


        window.document.addEventListener('mouseover', this.override());

        if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
           csrftoken = window.document.getElementById('tracker-id').value;
        }

        search = window.location.search;
        params = new URLSearchParams(search);
        requested_size = params.get('mattress_size');
        console.log('Current userlang via props is ... ', this.props.userlang);
        // this.mattress_size_request();
        // this.get_offers();
        // this.init_subtotal();
        this.update_qty = this.update_qty.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if ( this.props.new_current_product !== prevProps.new_current_product && this.state.page_loading === true ) {

            // this.setState({name: this.props.src + 'ssss'});
            this.initProductPage();
            this.marketing_url_param();
        }

        if (this.props.children_products_detail !== prevProps.children_products_detail && this.props.children_products_detail.length === 15) {
            this.setState({
                page_loading: false,
            });
        }

        // if (this.props.subtotal !== undefined && (this.props.product_price !== prevProps.product_price) && this.props.product_price.length === 15 ){
        if ( this.props.subtotal !== undefined && this.props.product_price.length === 18 ){
            // console.log(`Product Prices`, this.props.product_price);
            // console.log('trying to update subtotal', this.state);
            this.is_product_discounted();
        }

        // console.log('current product', this.props.current_product);
    }

    override = () => {
        // console.log(`++++++++++-----------------========  OVERRIDE =========----------------`);
        // console.log(this.props);
        // const mattress_quantity = document.getElementById('quantity').value = '4';
        // this.props.calc_subtotal_qty(this.state);
    }

    initProductPage = () => {
        // console.log(_State);
        // console.log(this.state);
        // console.log(this.props.current_product.price[1]);

        // console.log(`>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Mattress Page Init <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<`);
        // console.log(this.props);
        // console.log(this.state);
        // console.log(this.props.subtotal);

        const mattress_quantity = document.getElementById('quantity').value;
        const mattress_size= document.getElementById('mattress_size').value;
        const mattress_comfort = document.getElementById('comfort').value;
        mattress_category = document.getElementsByClassName('hero hero--chill')[0].dataset.productCategory;
        product_description = document.getElementById('configurator').dataset.description;

        // console.log(`INtro Category: ${mattress_category}, Comfort: ${mattress_comfort}, Size: ${mattress_size}, Quantity: ${mattress_quantity}`);
        /* Step --- not required update product  */


        this.setState({
                quantity: mattress_quantity,
                comfort: mattress_comfort,
                size: mattress_size,
                product_page_category: mattress_category,
                current_product: this.props.new_current_product,
        },() => {
            // console.log(this.state.current_product[0].price);
        });

    }

    is_product_discounted = () =>{
        let is_discounted = false;
        let is_discounted_voucher = false;
        let subtotal;
        // console.log(`new current product`, this.props.new_current_product)
        // console.log(`new current product length`, this.props.new_current_product.length)
        // console.log(`New Props`,this.props)
        // if ( this.props.new_current_product.length > 0 && this.props.offers_set === true && this.props.product_id_set === 0) {
        if ( this.props.offers_set === true && this.props.product_id_set === 0) {

            // console.log('ONLY ONE Prop');
            // console.log(`new current product`,this.props.new_current_product)

            const mattress_quantity = document.getElementById('quantity').value;
            const mattress_size= document.getElementById('mattress_size').value;
            const mattress_comfort = document.getElementById('comfort').value;
            const current_product_id = this.props.new_current_product.id;
            const data = this.props.product_price;
            const current_product =data.filter(item => item.id === current_product_id);
            // console.log('Current Discounted State', this.state)
            let product_id = this.props.new_current_product.id;
            let p_id;
            let offer_products, voucher_products, offer, voucher, products;
            // console.log('product_id_set: ', this.props.product_id_set)

            if (this.props.offers.length > 0) {

                let p_id = product_id;
                for (let i=0; i < this.props.offers.length; i++) {

                    let data = this.props.offers[i];
                    // console.log(`Key: ${i}, Value: ${data}`);
                    for (let [key, value] of Object.entries( data )) {

                        if (value['product_id'] === product_id) {
                            is_discounted = true;
                            p_id = value['product_id']
                            offer = {
                                'name': value['offers'].name,
                                'amount': value['offers'].amount,
                                'type': value['offers'].type
                            }
                            break;
                        }
                    }

                }

            }

            if (this.props.vouchers.length > 0) {

                for (let j=0; j < this.props.vouchers.length; j++) {
                    let data = this.props.vouchers[j];
                    for (let [key, value] of Object.entries( data )) {
                        // console.log(`Key: ${key}, Value: ${value}`);
                        if (value['product_id'] === product_id) {
                            is_discounted_voucher = true;
                            p_id = value['product_id']
                            voucher = {
                                'name': value['offers'].name,
                                'amount': value['offers'].amount,
                                'type': value['offers'].type
                            }
                            break;
                        }
                    }
                }

            }

            if (is_discounted){
                // console.log('offer discounted')
                //this.calc_subtotal_qty(this.state, offer)

                subtotal = parseFloat(mattress_quantity) * parseFloat(current_product[0].price.excl_tax);
                if (offer.type === 'Absolute') {
                    subtotal = (subtotal - offer.amount).toFixed(2);
                }else{
                    const discount = ( (parseFloat(mattress_quantity) * parseFloat(current_product[0].price.excl_tax)) * parseFloat(offer.amount/100));
                    subtotal = (subtotal - discount).toFixed(2);
                }

                if (this.props.is_discounted_set === false && this.props.product_id_set === 0) {
                    const is_discounted_set = true;
                    const product_id_set = p_id;
                    const original_price = parseFloat(current_product[0].price.excl_tax).toFixed(2)
                    this.props.set_is_discounted(is_discounted_set, product_id_set, subtotal, original_price)
                }

            }else if (is_discounted_voucher){
                // console.log('voucher discounted', voucher)
                subtotal = ( parseFloat(mattress_quantity) * parseFloat(current_product[0].price.excl_tax) );
                if (voucher.type === 'Absolute') {
                    subtotal = (subtotal - voucher.amount).toFixed(2);
                }else{
                    const discount = ( (parseFloat(mattress_quantity) * parseFloat(current_product[0].price.excl_tax)) * parseFloat(voucher.amount/100));
                    subtotal = (subtotal - discount).toFixed(2);
                }

                if (this.props.is_discounted_set === false && this.props.product_id_set === 0) {
                    const is_discounted_set = true;
                    const product_id_set = p_id;
                    const original_price = parseFloat(current_product[0].price.excl_tax).toFixed(2)
                    this.props.set_is_discounted(is_discounted_set, product_id_set, subtotal, original_price)
                }

            }else{
                // console.log(`current Product`, current_product);
                subtotal = ( parseFloat(mattress_quantity) * parseFloat(current_product[0].price.excl_tax) ).toFixed(2);
                if (this.props.is_discounted_set === false && this.props.product_id_set === 0) {
                    const is_discounted_set = false;
                    const product_id_set = -1;
                    const original_price = (parseFloat(mattress_quantity) * parseFloat(current_product[0].price.excl_tax) ).toFixed(2)
                    this.props.set_is_discounted(is_discounted_set, product_id_set, subtotal, original_price)
                }
            }

        }

    }

    marketing_url_param = () => {
        // console.log('Product Set', this.props.product_id_set);
        if (requested_size !== null && this.props.product_id_set !== 0 && this.state.capture_url_var === false){
            const url = new URL(window.location.href);
            const mattress_comfort = document.getElementById('comfort').value;
            // console.log('URL', url);
            // console.log('requested mattress size', requested_size); //i.e. Twin
            document.getElementById('mattress_size').value = requested_size;
            this.props.update_current_product(mattress_comfort, requested_size);
            // console.log('new mattress size', document.getElementById('mattress_size').value);
            this.props.reset_is_discounted();
            this.is_product_discounted();
            this.setState({
                capture_url_var: true,
            });
            // url.searchParams.delete('mattress_size');
            // url.searchParams.append('mattress_size', '');
            // requested_size = ''
            // window.history.replaceState(null, null, url.href);
            // console.log('URL 2 ', url)
        }
    }

    updateSubtotal = () =>{
        // console.log(`Subtotal ${this.state.subtotal}`);
        this.props.updateSubtotal(this.state.subtotal);
        // console.log(`Props`);
        // console.log(this.props);
    }

    /* Adding Product to basket */

    add_product = (e) => {
        e.target.setAttribute("disabled", true); // Redirect URL to Basket after success
        console.log(`latest props`, this.props);
        this.setState({
            loading: true
        })

        // console.log("Checking Initial props before Adding Product to basket");
        this.props.testChildproducts();
        // alert(window.Cartbasket.external_component());
        // console.log("Add Product To Basket");
        const product = this.props.new_current_product;
        const product_detail = this.props.children_products_detail;
        const product_options = product_detail.filter(item => item.id === product.id);

        // console.log(product);
        const mattress_quantity = document.getElementById('quantity').value;
        const mattress_size= document.getElementById('mattress_size').value;
        const mattress_comfort = document.getElementById('comfort').value;

        // console.log(`Products Detail`, product_detail);
        // console.log(`Product to Add Detail`, product_options);

        let options = [];
        for (let [key, value] of Object.entries(product_options[0].options) ) {
            // console.log(`${key}: ${value}`);
            if (value.code === 'comfort') {
                options=options.concat({
                    "option": value.url,
                    "value": mattress_comfort
                });
            }else if(value.code === 'size') {
                options=options.concat({
                    "option": value.url,
                    "value": mattress_size
                });
            }
        }

        // console.log("Product Options TO Send");
        // console.log(options);

        const product_data = {
            "url": product_options[0].url,
            "quantity": mattress_quantity,
            "options": options
        }

        this.props.process_successfule_product_add(product_data);

        // if (process === true) {
        //     this.setState({
        //         loading: true
        //     })
        // }


        // this.props.testChildproducts();
    }


    update_size = (e) => {
        // console.log(`>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Mattress Page Size Option <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<`);
        console.log(`Size: ${e.target.value}`);
        console.log(this.props);

        const mattress_size= e.target.value;
        const mattress_quantity = document.getElementById('quantity').value;
        const mattress_comfort = document.getElementById('comfort').value;

        if (requested_size !== ""){
            const url = new URL(window.location.href);
            url.searchParams.delete('mattress_size');
            // url.searchParams.append('mattress_size', '');
            requested_size = ''
            window.history.replaceState(null, null, url.href);
            console.log('URL 2 ', url)
        }

        this.props.reset_is_discounted();
        this.props.update_current_product(mattress_comfort, mattress_size);

        // this.props.is_product_discounted();

        // this.props.calc_subtotal_qty(mattress_quantity);
    }

    mattress_size_request = () => {
        //capture url variable and set new mattress size
        // const mattress_comfort = document.getElementById('comfort').value;

        // if (requested_size !== ""){
        //     console.log('mattress size', requested_size) //i.e. Twin
        // }
    }

    update_comfort = (e) => {
        // console.log(`>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Mattress Page Comfort Option <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<`);
        // console.log(`Comfort: ${e.target.value}`);
        // console.log(this.props);

        const mattress_comfort = e.target.value;
        const mattress_quantity = document.getElementById('quantity').value;
        const mattress_size = document.getElementById('mattress_size').value;
        console.log(`Comfort Size '${document.getElementById('mattress_size').value}'`, document.getElementById('mattress_size').value);
        this.props.update_current_product(mattress_comfort, mattress_size);

        // this.props.calc_subtotal_qty(mattress_quantity);
    }

    update_qty (e) {

        console.log(`>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Mattress Page QTY Option <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<`);
        console.log(this.props);

        const mattress_quantity = document.getElementById('quantity').value;
        const mattress_size= document.getElementById('mattress_size').value;
        const mattress_comfort = document.getElementById('comfort').value;
        this.props.reset_is_discounted();
        // this.props.calc_subtotal_qty(e.target.value);

    }


    calc_subtotal_qty = (quantity) => {
        // console.log(`>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Mattress Page Calc Subtotal <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<`);
        // console.log(this.props);
        console.log(`>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Mattress Page Calc Subtotal Current Price <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<`);
        // console.log( this.props.current_product[0].price.excl_tax);

        const subtotal = (parseFloat(quantity) * parseFloat(this.props.current_product[0].price.excl_tax)).toFixed(2);

        // console.log(`subtotal qty ${subtotal}`);

        this.setState({
                subtotal: subtotal,

        });

        // console.log(`Calculating subtotal Subtotal ... Quantity: ${this.state.quantity}`);
    }

    handleCurrentProducts = () => {
        // console.log(this.state.current_product);
        // this.props.setCurrentProduct(this.state.current_product);
    }

    get_product_by_class_options = () => {

    }

    get_current_product_orig_price = () => {
        // console.log(`//////////////////////////////////////// Orginal Price //////////////////////////////////////////////////`);
        // console.log(this.props.original_price);
        // return parseFloat(this.state.current_product[0].price.excl_tax).toFixed(2);
        const original_price = this.props.get_current_product_orig_price();
    }

    // get active discount offers  & vouchers i.e coupons
    get_offers = () => {
        // if (this.state.offers_set === false) {
        //     getOffers().then( (data) => {
        //         this.setState({
        //             offers: data.offers,
        //             vouchers: data.vouchers,
        //             offers_set: true
        //         })
        //     })
        // }
        if (this.props.is_discounted_set === false && this.state.offers_set === false)
            this.props.is_product_discounted();
    }

    render() {
        // let test = this.props.subtotal;
        let original_price = this.props.original_price;
        let subtotal = this.props.subtotal;
        const htmlToText = require('html-to-text');

            return(
                <React.Fragment>
                    <div className="configurator" data-place-react="configurator" data-pid="19" data-upsell-product-pids="[36]" data-title="Classic Mattress" data-cart-url="/store/basket/"
                    data-basket-lines="">
                        <div >
                            <h1 className="mattress-title">{ this.props.product_page_category === 'cocoon-classic'?'Cocoon Classic':'Cocoon Essential' }</h1>

                            <div className="mattress-description" id="product-description">
                                {
                                    // htmlToText.fromString(product_description, {
                                    //     // wordwrap: 130,
                                    //     preserveNewlines: true
                                    //   })
                                    parse(product_description)
                                }
                            </div>

                            <h2 className="mattress-subtitle">{this.props.userlang ==='fr'? 'Configurez votre set' : 'Configure your set'}</h2>
                            <Loader type="ThreeDots" color="#f9bd4f" height={80} width={80} visible={this.state.page_loading} className="myload" />

                            <div className={this.state.page_loading === true ?'mattress-form-selects hide-show':'mattress-form-selects'} >
                                <div className="quantity-select"><select
                                        id="quantity" className="select select--not-styled select--alto-border select--large-down-arrow quantity" onChange={this.update_qty} autoComplete="off">
                                        <option value="1">{this.props.userlang ==='fr'? 'Qté' : 'Qty'}: 1</option>
                                        <option value="2">{this.props.userlang ==='fr'? 'Qté' : 'Qty'}: 2</option>
                                        <option value="3">{this.props.userlang ==='fr'? 'Qté' : 'Qty'}: 3</option>
                                        <option value="4">{this.props.userlang ==='fr'? 'Qté' : 'Qty'}: 4</option>
                                        <option value="5">{this.props.userlang ==='fr'? 'Qté' : 'Qty'}: 5</option>
                                    </select></div>
                                <div className="configurator__options configurator__options--upsell">
                                    <div className="sizes options"><select
                                            id="mattress_size" className="select select--not-styled select--alto-border select--large-down-arrow options_size"
                                            name="option_size" onChange={this.update_size} autoComplete="off">
                                            <option value="Twin">{this.props.userlang ==='fr'? 'Simple' : 'Twin'}</option>
                                            <option value="Twin XL">{this.props.userlang ==='fr'? 'Simple XL' : 'Twin XL'}</option>
                                            <option value="Full">{this.props.userlang ==='fr'? 'Double' : 'Full'}</option>
                                            <option value="Queen">{this.props.userlang ==='fr'? 'Grand' : 'Queen'}</option>
                                            <option value="King">{this.props.userlang ==='fr'? 'Très grand' : 'King'}</option>
                                        </select></div>
                                    <div className="feel options"><select
                                            id="comfort" className="select select--not-styled select--alto-border select--large-down-arrow option_firmness"
                                            name="option_firmness" onChange={this.update_comfort} autoComplete="off">
                                            {
                                                this.props.product_page_category === 'cocoon-classic' ?
                                                <React.Fragment>
                                                    <option value="Soft">{this.props.userlang ==='fr'? 'Moelleux' : 'Soft'}</option>
                                                    <option value="Firm">{this.props.userlang ==='fr'? 'Ferme' : 'Firm'}</option>
                                                </React.Fragment>
                                                :
                                                <React.Fragment>
                                                    <option value="Medium">{this.props.userlang ==='fr'? 'Moyen' : 'Medium'}</option>
                                                </React.Fragment>
                                            }
                                        </select></div>
                                </div>
                                {/* <div className="upsell-products">
                                    <div className="mattress-hr">&nbsp;</div>
                                    <h3 className="upsell-products__subtitle">Complete your Bed</h3>
                                    <div className="products">
                                        <div className="upsell-product-line">
                                            <div className="upsell-left-column">
                                            <label>
                                                    <input className="al-checkbox-pdp" type="checkbox" /> Add</label>
                                                <select
                                                    className="select select--not-styled select--no-border select--small-down-arrow upsell-product-line__quantity">
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                </select></div>
                                            <div className="upsell-middle-column"><a
                                                    href="https://www.cocoonbysealy.com/accessories/foundation/v/40/"
                                                    className="upsell-product-line__size-title">Queen Cocoon Foundation(s)</a>
                                            </div>
                                            <div className="upsell-right-column"><span
                                                    className="upsell-product-line__price">+$299</span></div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className={this.state.page_loading === true ?'mattress-hr hide-show':'mattress-hr'}>&nbsp;</div>
                            <div className={this.state.page_loading === true ? 'continue continue--upsell hide-show': 'continue continue--upsell'}>
                                <div className="continue__left-column">
                                    <p className="continue-subtitle">{this.props.userlang ==='fr'? 'Sous-total': 'Subtotal'}</p>
                                </div>
                                <div className="continue__right-column">
                                    { (this.props.is_discounted_set === true )?
                                    <React.Fragment>
                                    <p className="original-price">${original_price}</p>
                                    <p className="price">${subtotal}</p>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                    <p className="price">${original_price}</p>
                                    </React.Fragment>
                                }
                                </div>

                                <button type="submit" id="add-to-cart-btn"
                                    className={
                                        this.state.loading === true ?'continue has-discounted-price al-configurator__add-to-cart diasbled-filter': 'continue has-discounted-price al-configurator__add-to-cart' }
                                        disabled={this.state.loading} onClick={this.add_product}
                                >
                                        {this.state.loading && (
                                            <i
                                                className="fa fa-refresh fa-spin"
                                                style={{ marginRight: "5px" }}
                                            />
                                        )}
                                        {this.state.loading && <span>{this.props.userlang ==='fr'? 'Ajouter au panier' : 'ADD TO CART'}</span>}
                                        {!this.state.loading && <span>{this.props.userlang ==='fr'? 'Ajouter au panier' : 'ADD TO CART'}</span>}
                                    </button>



                                <div style={ {lineHeight:'12px', fontSize:'8px', textAlign:'left', marginTop:'15px'} }>
                                    {/* <span>{this.props.userlang ==='fr'? '*Offre applicable à l’achat d’un matelas par commande. L’offre ne s’applique pas aux achats précédents et ne peut être combinée à d’autres offres sur des matelas ou codes promotionnels. L’offre n’est pas valide dans les points de vente au détail.' : '*Offer valid towards the purchase of one mattress per order. Offer not valid on previous purchases and offer cannot be combined with other mattress offers or promotional codes. Offer not valid at retail locations.'}</span>                                </div> */}

                                    <span>{this.props.userlang ==='fr'? '*Offre applicable à l’achat d’un matelas par commande. L’offre ne s’applique pas aux achats précédents et ne peut être combinée à d’autres offres sur des matelas ou codes promotionnels. L’offre n’est pas valide dans les points de vente au détail. Si le matelas est retourné, vous serez remboursé du coût du matelas moins la valeur des oreillers au plein prix de détail.' : '*Offer valid towards the purchase of one mattress per order. Offer not valid on previous purchases and offer cannot be combined with other mattress offers or promotional codes. Offer not valid at retail locations. If mattress is returned you will be refunded the cost of mattress minus the value of pillows at full retail price.'}</span>                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );

    }
}

export default Mattresspage;
